/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4l4 -6", "key": "svg-0" }]];
const IconCrown = createReactComponent("outline", "crown", "Crown", __iconNode);

export { __iconNode, IconCrown as default };
//# sourceMappingURL=IconCrown.mjs.map
